// src/components/store/sections/blog-posts/BlogV7PolaroidstoriesOceanCyan.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV7PolaroidstoriesOceanCyan(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={7}
      archKey="polaroid_stories"
      archLabel="Polaroid Story Frames"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
